import { Spin, Form, message, Input, Select, Modal, Row, Col } from "antd";
import { Button } from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import SingleLoanServices from "services/services/SingleLoanServices";
import BankServices from "services/services/BankServices";
import BankList from "./BankList";
import { TranslateString, convertToObjectKeyString } from "Utils/Common";
import { useIntl } from 'react-intl';
import BankNameList from "./BankNameList";
import { AiOutlinePlus } from 'react-icons/ai';

const Banks = (props: any) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<any>(false);
    const [editId, setEditId] = useState<any>();
    const [bankList, setBankList] = useState<any>();
    const [cityList, setCityList] = useState<any>();
    const [bankData, setBankData] = useState<any>();
    const [open, setOpen] = useState<any>();
    const [openPop, setOpenPop] = useState<any>();
    const [confirmLoading, setConfirmLoading] = useState<any>();
    const [editValue, setEditValue] = useState<any>();
    const [modalState, setModalState] = useState<any>();
    const [modalValue, setModalValue] = useState<any>();
    const [sort, setSort] = useState(false);
    const [bankNameSort, setBankNameSort] = useState(false);
    const [searchData, setSearchData] = useState<any>({ bank_name: "", city_id: "", city_name: "", bank_contact_name: "", bank_contact_email: "", bank_contact_phone: "", sort: "asc", sort_by: "" });
    const [openBN, setOpenBN] = useState<any>();
    const intl = useIntl();
    const [updatebtn, setUpdatebtn] = useState<any>(false);
    const bankNameRef = useRef<any>(null);
    const [bankNameList, setBankNameList] = useState<any>();
    const [totalRecords, setTotalRecords] = useState<any>(0);
    const [totalPages, setTotalPages] = useState<any>(0);
    const [searchBankNameData, setSearchBankNameData] = useState<any>({ bank_name: "", sort: "asc", sort_by: "bank_name" });
    const [pageData, setPageData] = useState<any>({ size: 5, page: 0 });
    const [paginationData, setPaginationData] = useState<any>({ page: 1, pageSize: 5 });


    useEffect(() => {
        getBankList();
    }, [searchData]);

    useEffect(() => {
        getBankData();
        getCities();
    }, []);

    const getBankData = () => {
        setLoading(true);
        let obj: any = {};
        obj.size = -1;

        SingleLoanServices
            .getAllBank(obj)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    let responseVal = response?.data?.data?.map((val: any) => {
                        return {
                            value: val?.bank_id,
                            label: val?.bank_name
                        }
                    });
                    setBankList(responseVal)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    };

    const getCities = () => {
        setLoading(true);

        let obj: any = {};
        obj.size = -1;
        BankServices
            .getAllCities(obj)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    let responseVal = response?.data?.data?.map((val: any) => {
                        return {
                            value: val?.kunta_id,
                            label: val?.city_name
                        }
                    });
                    setCityList(responseVal)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    };

    const getBankList = () => {
        setLoading(true);
        let object: any = {};
        object.bank_name = searchData?.bank_name
        object.city_id = searchData?.city_id
        object.city_name = searchData?.city_name
        object.bank_contact_name = searchData?.bank_contact_name
        object.bank_contact_email = searchData?.bank_contact_email
        object.bank_contact_phone = searchData?.bank_contact_phone
        object.sort = sort ? "desc" : "asc";
        object.sort_by = searchData.sort_by;

        BankServices
            .getAllBankContact(object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    let responseVal = response?.data?.data;
                    setBankData(responseVal)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    }

    const onFormSubmit = (values: any) => {
        if (editId) {
            let phone_number="";
            let phone_code="";
            if(editValue?.bank_contact_phone_code){
                phone_code = editValue?.bank_contact_phone_code;
            }
            if(editValue?.bank_contact_phone){
                phone_number = editValue?.bank_contact_phone;
            }

            const updateValue = {
                ...values,
                bank_contact_status: 1,
                bank_contact_id: editId,
                city_id: editValue?.city_id,
                city_name: editValue?.city_name,
                bank_contact_phone: phone_code ? "+" + phone_code +" "+phone_number.trim() : phone_number.trim()
            }
            const { bank_contact_phone_code, ...updateValueRest} = updateValue;

            setConfirmLoading(true);
            BankServices
                .updateBankContact(updateValueRest, editId)
                .then((response: any) => {
                    if (response?.data?.code === 200) {
                        message.success(intl.formatMessage({ id: convertToObjectKeyString('bank_contact_updated_successfully') }));
                        getBankList();
                        setEditId("");
                        setOpen(false);
                    }
                    if (response?.data?.code === 500) {
                        message.error(response?.data?.msg);
                    }
                    setConfirmLoading(false);
                })
                .catch((err: any) => {
                    setConfirmLoading(false);
                });
        } else {
            let phone_number="";
            let phone_code="";
            if(editValue?.bank_contact_phone_code){
                phone_code = editValue?.bank_contact_phone_code;
            }
            if(editValue?.bank_contact_phone){
                phone_number = editValue?.bank_contact_phone;
            }
            const saveValue = {
                ...values,
                bank_contact_status: 1,
                city_id: (typeof editValue?.city_id === 'undefined' ? null : editValue?.city_id),
                city_name: (typeof editValue?.city_name === 'undefined' ? "" : editValue?.city_name),
                bank_contact_phone: phone_code.length > 0 ? "+" + phone_code +" "+phone_number.trim() : phone_number.trim()
            }
            const { bank_contact_phone_code, ...saveValueRest} = saveValue;

            setConfirmLoading(true);
            BankServices
                .saveBankContact(saveValueRest)
                .then((response: any) => {
                    if (response?.data?.code === 200) {
                        message.success(intl.formatMessage({ id: convertToObjectKeyString('contact_save_successfully') }));
                        getBankList();
                        setOpen(false);
                    }
                    if (response?.data?.code === 500) {
                        message.error(response?.data?.msg);
                    }
                    setConfirmLoading(false);
                })
                .catch((err: any) => {
                    setConfirmLoading(false);
                });
        }
    };

    // on Add new bank
    const onBankNameSubmit = (values: any) => {
        const saveValue = { bank_name: editValue?.bank_name }
        setConfirmLoading(true);
        BankServices
            .saveBank(saveValue)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(intl.formatMessage({ id: convertToObjectKeyString('bank_saved_successfully') }));
                    getAllBankName();
                    getBankData();
                    // setOpenBN(false);
                    form.setFieldValue("bank_name", "");

                }
                if (response?.data?.code === 500) {
                    message.error(response?.data?.msg);
                }
                setConfirmLoading(false);
            })
            .catch((err: any) => {
                setConfirmLoading(false);
            });

    };

    const updateBankName = () => {
        let updateData:any = {};
        updateData.bank_status = 1;
        updateData.bank_name= editValue?.bank_name;
        let bankId = editValue?.bank_id;

        setLoading(true);
        SingleLoanServices
            .updateBankName(updateData, bankId)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(intl.formatMessage({ id: convertToObjectKeyString('bank_updated_successfully') }));
                    getAllBankName();
                    getBankData();
                    getBankList();
                    form.setFieldValue("bank_name", "");
                    setUpdatebtn(false);
                }
                if (response?.data?.code === 500) {
                    message.error(response?.data?.msg);
                }
                
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    };

    const deleteBankName = (formData:any) => {
        let updateData:any = {};
        updateData.bank_status = 0;
        // updateData.bank_name= formData?.bank_name;
        let bankId = formData?.bank_id;

        setLoading(true);
        SingleLoanServices
            .updateBankName(updateData, bankId)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(intl.formatMessage({ id: convertToObjectKeyString('bank_deleted_successfully') }));
                    getAllBankName();
                    getBankData();
                }
                if (response?.data?.code === 500) {
                    message.error(response?.data?.msg);
                }
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    };


    const onDeleteUser = (value: any) => {
        const deleteValue = {
            bank_contact_status: 0
        }
        setLoading(true);
        BankServices
            .updateBankContact(deleteValue, value?.bank_contact_id)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(intl.formatMessage({ id: convertToObjectKeyString('bank_contact_deleted_successfully') }));
                    getBankList();
                }
                if (response?.data?.code === 500) {
                    message.error(response?.data?.msg);
                }
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    };

    const onEditUser = (value: any) => {
        let checkVal = false;
        let phoneNumber = '';
        let phoneCode = '';
        bankList.forEach((element:any) => {
            if(element.value === value?.bank_id){
                checkVal = true;
            }
        });
        if(value?.bank_contact_phone && value?.bank_contact_phone.charAt(0) === "+"){
           let bankContact = value?.bank_contact_phone.substring(1);
           bankContact = bankContact.split(" ");
            phoneCode = bankContact[0];
            bankContact.shift();
            phoneNumber = bankContact.join(" ").trim();
        } else if(value?.bank_contact_phone) {
            phoneNumber = value?.bank_contact_phone.trim();
        }

        let obj = {
            bank_id: checkVal ? value?.bank_id : null,
            city_id: value?.city_id,
            bank_contact_name: value?.bank_contact_name,
            bank_contact_email: value?.bank_contact_email,
            bank_contact_phone: phoneNumber,
            bank_contact_phone_code: phoneCode
        }
        setEditValue(obj)
        setEditId(value.bank_contact_id);
        setOpen(true)
    };

    const handleOkPop = () => {
        if (modalState == "delete") {
            setOpenPop(false)
            onDeleteUser(modalValue)
        }
    }

    const editBankName = (data: any) => {
        form.setFieldValue("bank_name", data?.bank_name);
        bankNameRef.current.focus();
        setEditValue({...editValue, bank_name: data?.bank_name, bank_id: data?.bank_id});
        
        
    }

    const getAllBankName = () => {
        setLoading(true);
        let obj: any = {};
        obj.size = pageData?.size;
        obj.page = pageData?.page;
        obj.bank_name = "" ;
        if(searchBankNameData?.bank_name && searchBankNameData?.bank_name !== ""){
            obj.bank_name = searchBankNameData?.bank_name;
        }
        obj.sort = bankNameSort ? "desc" : "asc";
        // obj.sortBy = searchBankNameData?.sort_by;
        obj.sortBy = "bank_name";

        SingleLoanServices
            .getAllBank(obj)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    let responseVal = response?.data?.data?.map((val: any) => {
                        return {
                            value: val?.bank_id,
                            label: val?.bank_name
                        }
                    });
                    setBankNameList(responseVal);
                    setTotalPages(response?.data?.total_pages);
                    setTotalRecords(response?.data?.total_records);
                    setPaginationData({ page: 1, pageSize: paginationData.pageSize });
                }
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    };

    return (
        <>
            <Spin spinning={loading}>
                <BankList
                    onDeleteUser={onDeleteUser}
                    onEditUser={onEditUser}
                    bankData={bankData}
                    setOpen={setOpen}
                    setOpenBN={setOpenBN}
                    setEditId={setEditId}
                    setEditValue={setEditValue}
                    setModalState={setModalState}
                    setModalValue={setModalValue}
                    setOpenPop={setOpenPop}
                    setSort={setSort}
                    sort={sort}
                    setSearchData={setSearchData}
                    searchData={searchData}
                    setUpdatebtn={setUpdatebtn}
                    setSearchBankNameData={setSearchBankNameData}
                    searchBankNameData={searchBankNameData}
                />
            </Spin>
            <Modal title={editId ? TranslateString('edit_bank_contact_details') : TranslateString('add_bank_contact_details')} open={open} footer={false} destroyOnClose closable={false}>
                <Form
                    requiredMark={false}
                    onFinish={onFormSubmit}
                    layout="vertical"
                    initialValues={{ bank_id: editValue?.bank_id, city_id: editValue?.city_id, bank_contact_name: editValue?.bank_contact_name, bank_contact_email: editValue?.bank_contact_email, bank_contact_phone: editValue?.bank_contact_phone,bank_contact_phone_code: editValue?.bank_contact_phone_code }}
                >
                    <Form.Item
                        label={<><span>{TranslateString('bank_name')}</span><span className="text-danger">*</span></>}
                        name="bank_id"
                        rules={[{ required: true, message: TranslateString('please_enter_bank_name') }]}
                        className="mb-1"
                    >
                        <Select
                            placeholder={TranslateString('select')}
                            className="w-100"
                            allowClear
                            options={bankList}
                            onChange={(val) => {
                                setEditValue({ ...editValue, bank_id: val })
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<><span>{TranslateString('city_name')}</span></>}
                        name="city_id"
                        rules={[{ required: false, message: TranslateString('please_enter_city_name') }]}
                        className="mb-1"
                    >
                        <Select
                            placeholder={TranslateString('select')}
                            showSearch
                            filterOption={(input: any, option: any) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            className="w-100"
                            allowClear
                            options={cityList}
                            onChange={(val, foo) => {
                                setEditValue({
                                    ...editValue,
                                    city_id: typeof val === "undefined" ? null : val,
                                    city_name: typeof foo?.label === "undefined" ? "" : foo?.label
                                })
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<><span>{TranslateString('contact_name')}</span></>}
                        name="bank_contact_name"
                        rules={[{ required: false, message: TranslateString('please_enter_contact_name') }]}
                        className="mb-1"
                    >
                        <Input
                            onChange={(event: any) => setEditValue({ ...editValue, bank_contact_name: event.target.value })}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<><span>{TranslateString('email_contact')}</span><span className="text-danger">*</span></>}
                        name="bank_contact_email"
                        rules={[{ required: true, message: TranslateString('the_input_is_not_valid_email'), type: "email" }]}
                        className="mb-1"
                    >
                        <Input
                            onChange={(event: any) => setEditValue({ ...editValue, bank_contact_email: event.target.value })}
                        />
                    </Form.Item>
                    <Row className="mb-2">
                        <Col sm={6}>
                            <Form.Item
                                label={<><span>{TranslateString('phone_number')}</span></>}
                                name="bank_contact_phone_code"
                                rules={[{ required: false, message: TranslateString('please_enter_phone_number_between_8_to_12_digits'), 
                                pattern: new RegExp(/^(\d{2}|\d{3})$/)}]}
                            >
                                <Input
                                    addonBefore={<AiOutlinePlus />}
                                    onChange={(event: any) => setEditValue({ ...editValue, bank_contact_phone_code: event.target.value })}
                                />
                            </Form.Item>
                        </Col>
                        <Col sm={18}>
                            <Form.Item
                                label={<><span>&nbsp;</span></>}
                                name="bank_contact_phone"
                                rules={[{
                                validator(rule, value){
                                    return new Promise((resolve, reject) => {
                                        let pattern= new RegExp(/^(\d{7}|\d{8}|\d{9}|\d{10}|\d{11}|\d{12}|\d{13})$/);
                                        let currentVal="";
                                        if(value && value.length > 0){
                                            currentVal = value.replace(/ +/g, "");
                                        }
                                        if(currentVal.match(pattern) && (currentVal.length > 6 && currentVal.length < 14 )){
                                            resolve(true);
                                        } else if (currentVal !== "") {
                                            reject(intl.formatMessage({ id: convertToObjectKeyString('please_enter_phone_number_between_8_to_12_digits') }))
                                        } else {
                                            resolve(true);
                                        }
                                    })
                                }
                                }]}
                                className="ps-1"
                            >
                                
                                <Input
                                    onChange={(event: any) => setEditValue({ ...editValue, bank_contact_phone: event.target.value })}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end mt-2">
                        <Button type="reset" className="btn btn-sm btn-secondary px-4" onClick={() => {
                            setOpen(false)
                            setEditId("")
                            setEditValue("")
                        }}>{TranslateString('cancel')}</Button>
                        &nbsp;
                        <Button type="submit" className="btn btn-sm btn-light px-3 cu-btn-green" disabled={confirmLoading}>{confirmLoading ? TranslateString("Please Wait") : TranslateString('save')}</Button>
                    </div>
                </Form>
            </Modal>
            <Modal
                title=""
                open={openPop}
                onOk={handleOkPop}
                okButtonProps={{ className: 'cu-bg-green' }}
                okText={TranslateString('yes')}
                cancelText={TranslateString('no')}
                cancelButtonProps={{ className: 'cu-bg-green' }}
                confirmLoading={confirmLoading}
                onCancel={() => setOpenPop(false)}
            >
                <p className='h5'>{modalState === 'delete' ? TranslateString(`are_you_sure_you_want_to_delete_bank_contact_details`) : `Are you sure you want to edit bank contact details?`}</p>

            </Modal>

            {/* Add bank name popup */}
            <Modal title={TranslateString('add_bank_name')} 
                open={openBN} 
                footer={false} 
                destroyOnClose
                closable={false}
                width={700}
                >
                <Form
                    form={form}
                    requiredMark={false}
                    onFinish={updatebtn ? updateBankName: onBankNameSubmit }
                    layout="vertical"
                    className="row"
                >

                    <Form.Item
                        label={<><span>{TranslateString('bank_name')}</span><span className="text-danger">*</span></>}
                        name="bank_name"
                        rules={[{ required: true, message: TranslateString('please_enter_bank_name') }]}
                        className="col-sm-7 mb-1"
                    >
                        <Input
                            ref={bankNameRef}
                            onChange={
                                (event: any) => setEditValue({ ...editValue, bank_name: event.target.value })
                            }
                        />
                    </Form.Item>
                    <div className="d-flex justify-content-end py-4 col-sm-5">
                        <Button type="reset" className="btn btn-sm btn-secondary px-4" onClick={() => {
                            setOpenBN(false)
                        }}>{TranslateString('cancel')}</Button>
                        &nbsp;
                        <Button type="submit" className="btn btn-sm btn-light px-3 cu-btn-green" disabled={confirmLoading}>{confirmLoading ? TranslateString("Please Wait") : TranslateString('save')}</Button>
                    </div>
                    </Form>

                    {/*  Bank name listing page   */}
                    <Spin spinning={loading}>
                        <BankNameList
                            setLoading={setLoading}
                            editBankName={editBankName}
                            updateBankName={updateBankName}
                            deleteBankName={deleteBankName}
                            setUpdatebtn={setUpdatebtn}
                            bankNameList={bankNameList}
                            getAllBankName={getAllBankName}
                            searchBankNameData={searchBankNameData}
                            setSearchBankNameData={setSearchBankNameData}
                            setPageData={setPageData}
                            setBankNameSort={setBankNameSort}
                            bankNameSort={bankNameSort}
                            totalRecords={totalRecords}
                            totalPages={totalPages}
                            pageData={pageData}
                            paginationData={paginationData}
                            setPaginationData={setPaginationData}
                        />
                    </Spin>
            </Modal>
        </>
    );
};
export default Banks;